import Swiper from 'swiper'
import { Autoplay, EffectFade, Pagination, Navigation, Thumbs } from 'swiper/modules'

import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

class Carousel {
  constructor(el) {
    this.carouselEl = el.querySelector('.slider')
    this.slides = this.carouselEl.querySelectorAll('.slide')

    this.pagination = this.carouselEl.querySelector('.slider-pagination')

    /**
     * All the dataset attributes
     * @param	{Object}	this.data
     * @param	{string}	this.data
     */
    this.data = this.carouselEl.dataset

    this.anim = (this.data.animationType) ? this.data.animationType.toLowerCase() : 'slide'
    this.modules = []

    if (this.data.thumbsSelector !== undefined) {
      this.thumbnailsElSelector = this.data.thumbsSelector
      this.thumbs = document.querySelector(this.thumbnailsElSelector)
      this.thumbsType = this.thumbs.tagName

      /** Non-swiper case for thumbs */
      if (this.thumbsType.toLowerCase() !== 'carousel') {
        if (this.pagination) {
          this.pagination = {
            el: this.thumbs,
            type: 'bullets'
          }
        }

        this.thumbs = false
      }
    }

    this.init()
  }

  // TODO: Setup event case for non-carousel thumbs
  // TODO: Alternative effects cases
  init() {
    /** --- Enable Fade --- */
    if (this.anim == 'fade') {
      Swiper.use(Autoplay, EffectFade)

      this.modules.push(EffectFade)
    }

    /** --- Enable Thumbs --- */
    if (this.thumbs !== false) {
      Swiper.use(Thumbs)

      this.modules.push(Thumbs)
    }

    /** --- Enable Pagination --- */
    if (this.pagination !== undefined) {
      Swiper.use(Pagination)

      this.modules.push(Pagination)
    }

    /** --- Enable Navigation --- */
    if (this.navigation !== undefined) {
      Swiper.use(Navigation)

      this.modules.push(Navigation)
    }

    const gutter = (this.data.gutter) ? parseInt(this.data.gutter) : 16
    const tabletGutter = (this.data.tabletGutter) ? parseInt(this.data.tabletGutter) : this.data.gutter
    const desktopGutter = (this.data.desktopGutter) ? parseInt(this.data.desktopGutter) : this.data.tabletGutter ? parseInt(this.data.tabletGutter) : 30

    this.options = {

      autoplay: (this.data.autoplay != undefined) ? {
        delay: parseFloat(this.data.timing)
      } : false,
      breakpoints: {
        769: {
          spaceBetween: tabletGutter,
          slidesPerView: (parseFloat(this.data.perViewTablet) > 1 && parseFloat(this.data.perViewTablet)) || parseFloat(this.data.perView) || 1
        },
        1240: {
          spaceBetween: desktopGutter,
          slidesPerView: parseFloat(this.data.perViewDesktop) || (parseFloat(this.data.perViewTablet) > 1 && parseFloat(this.data.perViewTablet)) || this.data.slidesPerview && parseFloat(this.data.slidesPerView) || 1
        }
      },

      centeredSlides: (this.data.centered != undefined),
      containerModifierClass: 'slider-',
      effect: this.anim,
      height: (this.data.height) ? parseInt(this.data.height) : null,
      loop: (this.data.loops != undefined),
      loopedSlides: (this.data.loops != undefined) ? this.slides.length : null,
      modules: this.modules,
      navigation: (this.navigation != undefined) ? {
        disabledClass: 'slider-button-disabled',
        enabled: true,
        hiddenClass: 'slider-button-hidden',
        hideOnClick: false,
        lockClass: 'slider-button-lock',
        navigationDisabledClass: 'slider-navigation-disabled',
        nextEl: this.carouselEl.querySelector('.slider-button-next'),
        prevEl: this.carouselEl.querySelector('.slider-button-prev')
      } : false,
      pagination: (this.pagination != undefined) ? {
        bulletActiveClass: 'active',
        bulletClass: 'slider-pagination-bullet',
        clickable: true,
        clickableClass: 'slider-pagination-clickable',
        currentClass: 'slider-pagination-current',
        modifierClass: 'slider-pagination-',
        el: (this.pagination.el) ? this.pagination.el : this.carouselEl.querySelector('.slider-pagination'),
        type: (this.pagination.type) ? this.pagination.type : 'bullets'
      } : false,
      slideActiveClass: 'slide-active',
      slideClass: 'slide',
      slideDuplicateActiveClass: 'slide-active-duplicate',
      slideDuplicateClass: 'slide-duplicate',
      slideDuplicateNextClass: 'slide-next-duplicate',
      slideDuplicatePrevClass: 'slide-prev-duplicate',
      slidePrevClass: 'slide-prev',
      slideNextClass: 'slide-next',
      slideVisibleClass: 'slide-visible',
      slidesPerView: parseFloat(this.data.perView) || 'auto',
      spaceBetween: gutter,
      speed: parseInt(this.data.speed),
      thumbs: this.thumbs,
      wrapperClass: 'slider-slides',
      on: {
        breakpoint: (swiper, breakpointParams) => {
          if (breakpointParams.spaceBetween >= 1000) {
            swiper.destroy()
          }
        },
        click: (swiper) => {

        },
        paginationRender: (swiper, paginationEl) => {

        },
        init: (swiper) => {

        },
        resize: (swiper) => {
          if (this.data.mobileOnly === '') {
            if (self.Decimal.windowWidth > 768) {
              swiper.destroy()
              swiper.el.classList.add('disabled')
            }
          } else if (this.data.tabletOnly === '') {
            if (self.Decimal.windowWidth > 1200) swiper.destroy()
          }
        }
      }
    }

    /** Effects */
    switch (this.carouselEl.dataset.effect) {
      case 'crossfade':

        this.options.fadeEffect = {
          crossFade: true
        }

        break

      default:

        break
    }

    if (this.data.mobileOnly === '') {
      if (self.Decimal.windowWidth <= 768) {
        this.carouselEl.carousel = new Swiper(this.carouselEl, this.options)
      }
    }
    if (this.data.tabletOnly === '') {
      if (self.Decimal.windowWidth <= 1200) {
        this.carouselEl.carousel = new Swiper(this.carouselEl, this.options)
      }
    } else {
      this.carouselEl.carousel = new Swiper(this.carouselEl, this.options)
    }

    // this.carouselEl.carousel = new Swiper(this.carouselEl, this.options)
  }
}

// IIFE to invoke component on mount
(function init() {
  const carouselEls = document.querySelectorAll('[data-carousel]')

  carouselEls.forEach((el, i, arr) => {
    if (el.getAttribute('bound') !== null) return

    const carousel = new Carousel(el)

    el.setAttribute('bound', '')

    const id = arr.length > 1 ? `Carousel_${i}` : 'Carousel'

    self.Decimal.components[id] = { ...carousel, async: true }
  })
})()

export default Carousel
